import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=3be68d4a&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"
import style0 from "./UserView.vue?vue&type=style&index=0&id=3be68d4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be68d4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be68d4a')) {
      api.createRecord('3be68d4a', component.options)
    } else {
      api.reload('3be68d4a', component.options)
    }
    module.hot.accept("./UserView.vue?vue&type=template&id=3be68d4a&scoped=true", function () {
      api.rerender('3be68d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/UserView.vue"
export default component.exports